'use strict';

angular.module('lmsApp')
    .factory('Videoconfconfig', function ($resource) {
        return $resource('videoconf/list/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getConfByUserId': {
                method: 'GET',
                url: 'videoconf/list/:id',
                isArray: true
            },
            'updateGroupUser': {
                method: 'PUT',
                url: 'api/videoconfconfigs/groupUsers',
            }
        });
    });
